<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Rodzaje terminów</h4>
              <button v-if="hasPermission('canEditBHP')" @click="addTermin" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj nowy rodzaj terminu
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa terminu</th>
                  <th>Opis</th>
                  <th>Ile dni wcześniej</th>
                  <th>Sprawdzaj zmiany stanowiska</th>
                  <th v-if="hasPermission('canEditBHP')">Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(termin, index) in terminy" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input v-if="editingId === termin.id" v-model="termin.nazwa" class="form-control"/>
                    <span v-else>{{ termin.nazwa }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === termin.id" v-model="termin.opis" class="form-control"/>
                    <span v-else>{{ termin.opis }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === termin.id" v-model="termin.ile_wczesniej" class="form-control"
                           type="number"/>
                    <span v-else>{{ termin.ile_wczesniej }}</span>
                  </td>
                  <td>
                    <div v-if="editingId === termin.id"
                         class="checkbox-success custom-control custom-checkbox d-inline-block mt-1">
                      <input :id="'check-' + termin.id" type="checkbox" class="custom-control-input"
                             v-model="termin.check_position" :true-value="1" :false-value="0">
                      <label :for="'check-' + termin.id" class="custom-control-label h6"></label>
                    </div>
                    <div v-else class="checkbox-success custom-control custom-checkbox d-inline-block mt-1">
                      <input :id="'check-' + termin.id" type="checkbox" class="custom-control-input"
                             v-model="termin.check_position" :true-value="1" :false-value="0" disabled>
                      <label :for="'check-' + termin.id" class="custom-control-label h6"></label>
                    </div>
                  </td>
                  <td v-if="hasPermission('canEditBHP')">
                    <button v-if="editingId === termin.id" @click="updateTermin(termin)"
                            class="btn btn-sm btn-success me-2">Zapisz
                    </button>
                    <button v-else @click="editTermin(termin.id)" class="btn btn-sm btn-outline-info me-2"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button @click="deleteTermin(termin.id)" class="btn btn-sm btn-danger"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                <tr v-if="addingNew">
                  <td>Nowy</td>
                  <td><input v-model="newTermin.nazwa" class="form-control"/></td>
                  <td><input v-model="newTermin.opis" class="form-control"/></td>
                  <td><input v-model="newTermin.ile_wczesniej" class="form-control" type="number"/></td>
                  <td>
                    <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-1">
                      <input id="check_position" type="checkbox" class="custom-control-input"
                             v-model="newTermin.check_position" :true-value="1" :false-value="0">
                      <label for="check_position" class="custom-control-label h6"></label>
                    </div>
                  </td>
                  <td>
                    <button @click="saveNewTermin" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewTermin" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/BHP/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    terminy: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newTermin: this.getEmptyForm()
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
    getEmptyForm() {
      return {
        id: null,
        name: '',
        opis: '',
        ile_wczesniej: 14,
        jaki_dzial: 0,
        check_position: 1,
      };
    },
    addTermin() {
      this.addingNew = true;
      this.newTermin = this.getEmptyForm();
    },
    cancelNewTermin() {
      this.addingNew = false;
      this.newTermin = this.getEmptyForm();
    },
    editTermin(id) {
      this.editingId = id;
    },

    updateTermin(termin) {
      this.$inertia.put(route('bhp.terminy.update', termin.id), termin, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewTermin() {
      this.$inertia.post(route('bhp.terminy.dodaj'), this.newTermin, {
        onSuccess: () => {
          this.addingNew = false;
          this.newTermin = this.getEmptyForm();
        }
      });
    },
    deleteTermin(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie typu terminu',
        html: 'Czy na pewno chcesz usunąć wybrany typ terminu?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.terminy.usun', id));
        }
      });
    }
  }
};
</script>
